import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["linksCheckbox", "linksPanel"]

  connect() {
    this.#sync()
  }

  toggleLinks() {
    this.#sync()
  }

  closeLinks() {
    if (this.hasLinksCheckboxTarget) this.linksCheckboxTarget.checked = false
    this.#sync()
  }

  #sync() {
    if (!this.hasLinksCheckboxTarget || !this.hasLinksPanelTarget) return
    this.linksPanelTarget.classList.toggle("hidden", !this.linksCheckboxTarget.checked)
  }
}
